import { NAME_SEPARATOR, NAME_PREFIX } from './const';

export default (slug) => `${NAME_PREFIX}${NAME_SEPARATOR}${slug}`;
